import { ASLoader } from '@eleventheye/asui';
import { useAppSelector } from 'app/hooks';
import { getLoader } from 'app/slices/AppUiSlice';
import React, { useEffect, useState } from 'react';

export type UseLoaderHook = ReturnType<typeof useLoader>;
const useLoader = () => {
  const { visible, size, type, isModal } = useAppSelector(getLoader);
  const [loader, setLoader] = useState<React.ReactNode>();

  useEffect(() => {
    if (type && size) {
      setLoader(<ASLoader size={size} loaderType={type} showLoader={visible} isModal={isModal} />);
    }
  }, [type, size, visible, isModal]);

  return { loader, type, size, isLoaderOpen: visible, isModal };
};

export default useLoader;
